import dayjs from 'dayjs';

/** Parse ISO date string to dayjs or undefined */
export const toFormDate = (value?: string | null) => {
  if (!value) return undefined;
  const parsed = dayjs(value);
  return parsed.isValid() ? parsed : undefined;
};

/** Format ISO date string for display */
export const formatDateTime = (value?: string | null) => {
  if (!value) return '—';
  const parsed = dayjs(value);
  return parsed.isValid() ? parsed.format('YYYY-MM-DD HH:mm') : String(value);
};

/** Build Select options from entities with id+name */
export const normalizeSelectOptions = <T extends { id: number | string; name?: string | null }>(
  items: T[],
) =>
  items.map((item) => ({
    value: item.id,
    label: item.name ? `${item.name}` : String(item.id),
  }));

/** Normalize any id to string (UUID-safe) */
export const normalizeId = (value: any): string | undefined => {
  if (value === null || value === undefined) return undefined;
  return String(value);
};
